import { useParams, Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './tiles.scss';

/* This has not been updated yet and is currently just a copy of the CategoryList.js file. */
function CategoryCourseTile(courseOrCategory) {

    const navigate = useNavigate();

    return (
        <div className="summary-container">
            {/* These images are filling the entire space. Need to fix this. */}
            <div className="summary-container--image-holder">
                <img src={courseOrCategory.image} alt="Course or Category"  />
            </div>
            <div className="summary-container--text-holder">
                <h1 className="title">{courseOrCategory.title}</h1>
                <hr className="dashed-line" /> {/* Add this line */}
                <p className="content">{courseOrCategory.content}</p>
                <div className="summary-container--button-holder">
                <button className="btn btn-light  border rounded-pill" onClick={() => navigate('/categories/' + courseOrCategory.category)}>
                View Courses
              </button>
                </div>
            </div>
        </div>
    );
}

export default CategoryCourseTile;